import { render, staticRenderFns } from "./PrinterCodePage.vue?vue&type=template&id=4838d6ca&"
import script from "./PrinterCodePage.vue?vue&type=script&lang=js&"
export * from "./PrinterCodePage.vue?vue&type=script&lang=js&"
import style0 from "./PrinterCodePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports